export default "__VITE_ASSET__CD$qiuLT__"